import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { WEBHOOK_SETTINGS_API } from '../api/webhooks-api';
import { WebhookCreateInterface, WebhookErrorInterface, WebhookId, WebhookInterface, WebhookUpdateInterface } from '../types/webhook-settings-interface';
export const useWebhookSettingsApi = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.patch
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: patchFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  let t3;
  if ($[3] !== postFetcher) {
    t3 = body => postFetcher(WEBHOOK_SETTINGS_API, body);
    $[3] = postFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const create = t3;
  let t4;
  if ($[5] !== deleteFetcher) {
    t4 = id => deleteFetcher(`${WEBHOOK_SETTINGS_API}/${id}`);
    $[5] = deleteFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const remove = t4;
  let t5;
  if ($[7] !== patchFetcher) {
    t5 = (id_0, body_0) => patchFetcher(`${WEBHOOK_SETTINGS_API}/${id_0}`, body_0, {
      headers: {
        "Content-Type": "application/merge-patch+json"
      }
    });
    $[7] = patchFetcher;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const edit = t5;
  let t6;
  if ($[9] !== create || $[10] !== edit || $[11] !== remove) {
    t6 = {
      create,
      remove,
      edit
    };
    $[9] = create;
    $[10] = edit;
    $[11] = remove;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};